import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { selectHasMagicBorderApplied } from '@ff-scene-plugins/photo-prints-redux/slices/generalUiSlice';
import { selectActiveAccessoryId } from '@ff-scene-plugins/photo-prints-redux/slices/photosSlice';
import { PhotoPrintsPdpState } from '@ff-scene-plugins/photo-prints-redux/store';
import { VariantOption } from '../../../VariantOption';

export const useGroupTitle = ({
    groupId,
    size,
    paper,
    border
}: {
    groupId: string;
    size: VariantOption;
    paper: VariantOption;
    border?: VariantOption;
}): string => {

    const { t } = useTranslation();

    const {
        hasMagicBorder,
        accessoryId
    } = useSelector((state: PhotoPrintsPdpState) => ({
        hasMagicBorder: selectHasMagicBorderApplied(state, groupId),
        accessoryId: selectActiveAccessoryId(state, groupId)
    }));

    const hasAccessoryApplied = !!accessoryId;

    if (hasAccessoryApplied) {
        return t(size.name.key);
    }

    const sizeText = t(size.label!.key, size.label!.args);
    const paperText = t(paper.name.key, paper.name.args);

    let borderText = "";

    if (hasMagicBorder) {
        borderText = t("photo_prints.photo_fun");
    } else if (border) {
        borderText = t(border.name.key, border.name.args);
    }

    return t("photo_prints.group_name", {
        size: sizeText,
        paper: paperText,
        border: borderText
    });
};